import { styled } from '@mui/material'
import Box from '@mui/material/Box'

export const ContentWrapper = styled(Box)`
  height: 100%;
  width: 100%;
  display: flex;
`
